import { RefObject, useCallback, useMemo } from 'react';

import { KeySequenceDefinition, useKeySequenceListener } from '@dreryk/react-common';

import { useEmergencyNotification } from './useEmergencyNotification';

type EmergencyNotificationKeyboardListenerProps = {
   readonly buttonRef: RefObject<HTMLButtonElement | null>;
};

export const EmergencyNotificationKeyboardListener = (props: EmergencyNotificationKeyboardListenerProps): null => {
   const { state } = useEmergencyNotification();

   const handleTrigger = useCallback(() => {
      if (state.type === 'idle') {
         props.buttonRef.current?.click();
      }
   }, [state.type, props.buttonRef]);

   const sequences = useMemo<KeySequenceDefinition[]>(
      () => [
         {
            id: 'sos-shift-left',
            keys: ['ShiftLeft', 'ShiftLeft', 'ShiftLeft'],
            threshold: 600,
            callback: handleTrigger,
         },
         {
            id: 'sos-shift-right',
            keys: ['ShiftRight', 'ShiftRight', 'ShiftRight'],
            threshold: 600,
            callback: handleTrigger,
         },
      ],
      [handleTrigger]
   );

   useKeySequenceListener(sequences);

   return null;
};
